// src/components/TokenManager.js
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const TOKEN_REFRESH_MARGIN = 60_000;            // 1 min
const SESS_KEY_TOKEN      = 'SaaS_accessToken'; // sessionStorage keys
const SESS_KEY_EXP        = 'SaaS_tokenExp';

function TokenManager({ onTokenUpdate, userCredentials }) {
  // Pull from sessionStorage once; value is null if absent
  const [accessToken, setAccessToken]   = useState(
    sessionStorage.getItem(SESS_KEY_TOKEN)
  );
  const [tokenExpiration, setExpiration] = useState(
    sessionStorage.getItem(SESS_KEY_EXP)
      ? new Date(sessionStorage.getItem(SESS_KEY_EXP))
      : null
  );

  /* ---------------   Fetch / refresh token   --------------- */
  const fetchToken = useCallback(async () => {
    try {
      // Use provided user credentials if available, fallback to default
      const credentials = userCredentials || {
        username: 'esldashboard@outlook.com',
        password: 'SoluM@2020'
      };

      const { data } = await axios.post(
        'https://eastus.common.solumesl.com/common/api/v2/token',
        credentials
      );

      const { access_token, expires_in } = data.responseMessage;
      const exp = new Date(Date.now() + expires_in * 1000);

      sessionStorage.setItem(SESS_KEY_TOKEN, access_token);
      sessionStorage.setItem(SESS_KEY_EXP ,  exp.toISOString());

      setAccessToken(access_token);
      setExpiration(exp);
      onTokenUpdate(access_token);            // callback to parent
    } catch (err) {
      console.error('SaaS token fetch error', err);
    }
  }, [onTokenUpdate, userCredentials]);

  /* ---------------   Timer effect   --------------- */
  useEffect(() => {
    const maybeRefresh = async () => {
      const now = new Date();

      if (!accessToken || !tokenExpiration || tokenExpiration <= now ||
          tokenExpiration - now <= TOKEN_REFRESH_MARGIN) {
        await fetchToken();
      } else {
        onTokenUpdate(accessToken);
      }
    };

    maybeRefresh();                              // run once
    const id = setInterval(maybeRefresh, TOKEN_REFRESH_MARGIN);
    return () => clearInterval(id);
  }, [accessToken, tokenExpiration, fetchToken, onTokenUpdate]);

  return null;                                   // headless component
}

export default TokenManager;
